module.exports = __webpack_public_path__ + "img/happytable.1e510132.png";